module.exports = __webpack_public_path__ + "media/images/fallback_document-6f21da4ccb6bdada4f9bbab3648aead2.png";